export type SellerMaturity = 'new' | 'connected-empty' | 'established' | 'unknown'

export type SellerHomeSnapshot = {
  activeStores: number | null
  failingStores: number | null
  activeListings: number | null
  listingIssues: number | null
  orderTotal: number | null
  orderByState: Record<string, number> | null
}

export type SellerHomeActionKind =
  | 'store-failing'
  | 'seller-approval'
  | 'ready-for-shipping'
  | 'listing-issues'
  | 'connect-store'
  | 'create-listing'

export type SellerHomeAction = {
  kind: SellerHomeActionKind
  count: number
  to: string
}

export function deriveSellerMaturity(
  snapshot: Pick<SellerHomeSnapshot, 'activeStores' | 'activeListings' | 'orderTotal'>,
): SellerMaturity {
  if (snapshot.activeStores == null) return 'unknown'
  if (snapshot.activeStores === 0) return 'new'
  if (snapshot.activeListings == null || snapshot.orderTotal == null) return 'unknown'
  if (snapshot.activeListings === 0 || snapshot.orderTotal === 0) return 'connected-empty'
  return 'established'
}

export function rankSellerHomeActions(snapshot: SellerHomeSnapshot): SellerHomeAction[] {
  const actions: SellerHomeAction[] = []
  const orderByState = snapshot.orderByState ?? {}

  if ((snapshot.failingStores ?? 0) > 0) {
    actions.push({
      kind: 'store-failing',
      count: snapshot.failingStores ?? 0,
      to: '/seller/stores',
    })
  }
  if ((orderByState.awaiting_seller_approval ?? 0) > 0) {
    actions.push({
      kind: 'seller-approval',
      count: orderByState.awaiting_seller_approval,
      to: '/seller/my-orders?status=awaiting_payment',
    })
  }
  if ((orderByState.ready_for_shipping ?? 0) > 0) {
    actions.push({
      kind: 'ready-for-shipping',
      count: orderByState.ready_for_shipping,
      to: '/seller/my-orders?status=awaiting_shipment',
    })
  }
  if ((snapshot.listingIssues ?? 0) > 0) {
    actions.push({
      kind: 'listing-issues',
      count: snapshot.listingIssues ?? 0,
      to: '/seller/my-listings?status=issues',
    })
  }
  if (snapshot.activeStores === 0) {
    actions.push({ kind: 'connect-store', count: 1, to: '/seller/stores' })
  } else if (snapshot.activeStores != null && snapshot.activeListings === 0) {
    actions.push({ kind: 'create-listing', count: 1, to: '/seller/catalog' })
  }

  return actions
}
